import "devextreme/dist/css/dx.common.css";
import "./themes/generated/theme.base.dark.css";
import "./themes/generated/theme.base.css";
import "./themes/generated/theme.additional.dark.css";
import "./themes/generated/theme.additional.css";
import React from "react";
import { HashRouter as Router } from "react-router-dom";
import "./dx-styles.scss";
import LoadPanel from "devextreme-react/load-panel";
import { NavigationProvider } from "./contexts/navigation";
import { AuthProvider, useAuth } from "./contexts/auth";
import { useScreenSizeClass } from "./utils/media-query";
import Content from "./Content";
import UnauthenticatedContent from "./UnauthenticatedContent";
import { ThemeContext, useThemeContext } from "./theme";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { loadMessages, locale } from "devextreme/localization";
import ptMessages from "devextreme/localization/messages/pt.json";
import { config } from "devextreme/common";

function App() {
  const { user, loading } = useAuth();

  loadMessages(ptMessages);
  locale("pt");

  config({
    licenseKey:
      "ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImVlMGE5ZjlkLTE5MjgtNDhiYy04NWUzLTNmNWFhMjBjNDNiMSIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQyCn0=.G3ZuMAeTSUrwY2ngDA+1vrD/a99MQsDQQDDxQQCPKuESGD7u7Ewypeza/ZYJ6Hh4BWerN9tLWsLf2Ot527BC4axHq3efSM47WWrdE1Eo9eFKXs3mvLRVN3lzZHCeLQ/ao6RHUA==",
  });

  if (loading) {
    return <LoadPanel visible={true} />;
  }

  if (user) {
    return <Content />;
  }

  return <UnauthenticatedContent />;
}

export default function Root() {
  const screenSizeClass = useScreenSizeClass();
  const themeContext = useThemeContext();
  const [queryClient] = React.useState(() => new QueryClient());

  return (
    <Router>
      <ThemeContext.Provider value={themeContext}>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <NavigationProvider>
              <div className={`app ${screenSizeClass}`}>
                <App />
              </div>
            </NavigationProvider>
          </AuthProvider>
        </QueryClientProvider>
      </ThemeContext.Provider>
    </Router>
  );
}
